export default "/images/454fff0c80946a6b09d31eb5e22fd85b.avif";